/* tslint:disable */
/* eslint-disable */
/**
 * Its4Plan PDF Service
 * Its4Plan PDF Service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetSinglePriolistRequest {
    prio: number;
}

/**
 * 
 */
export class SinglePriolistPdfApi extends runtime.BaseAPI {

    /**
     */
    async getSinglePriolistRaw(requestParameters: GetSinglePriolistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['prio'] == null) {
            throw new runtime.RequiredError(
                'prio',
                'Required parameter "prio" was null or undefined when calling getSinglePriolist().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['prio'] != null) {
            queryParameters['prio'] = requestParameters['prio'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/priolist/single`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getSinglePriolist(requestParameters: GetSinglePriolistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getSinglePriolistRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
